import React, { useEffect, useState } from 'react';
import { Input, Pagination, Popconfirm, Select } from 'antd';
import { BOOKING_SUB_STATUS, getStatusClass } from 'utils/data';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { AppState } from 'interface/stateApp';
import { convertDateTime, getUrlPage, isValid } from 'utils/helper';
import toast, { NotifyType } from 'utils/toast';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookingSub } from 'interface/BookingSub';
import BookingSubModal from './modal/BookingSubModal';
import { BOOKING_SUB_SIZE, deleteBookingSubById, getBookingSubs } from 'service/bookingSubService';

const { Option } = Select;

export const BookingSubManager: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState<number>(BOOKING_SUB_SIZE);
  const [searchParams] = useSearchParams();
  const [bookingSubSize, setFeedBackSize] = useState(0);
  const [bookingSubs, setBookingSubs] = useState<BookingSub[]>([]);
  const [feedBackSelected, setFeedBackSelected] = useState<BookingSub | null>(null);
  const [stateApp, setStateApp] = useState<AppState>({
    showBookingSubForm: false,
  });

  const navi = useNavigate();


  const getData = (url?: string) => {

    getBookingSubs(url)
      .then((data) => {
        setBookingSubs(data?.content);
        setFeedBackSize(data?.totalElements);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let input = event.currentTarget.value;
    if (event.key === 'Enter') {
      if (input !== '') {
        navi(`/qna-tickets/booking-sub?keyword=${input}`);
      } else {
        navi(`/qna-tickets/booking-sub`);
      }
    }
  };

  const handleOnchangeSelect = (value: string) => {
    if (value === 'all') {
      navi(`/qna-tickets/booking-sub`);
    } else {
      navi(`/qna-tickets/booking-sub?status=${value}`);
    }
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize ? pageSize : BOOKING_SUB_SIZE);
    const searchParam = searchParams.get('keyword');
    const status = searchParams.get('status');
    let url = '/booking-sub';
    
    if (isValid(searchParam)) {
      url += `?keyword=${searchParam}`;
      getData(getUrlPage(url, page, pageSize ? pageSize : BOOKING_SUB_SIZE))
      return;
    }
    if (isValid(status)) {
      url += `?status=${status}`;
      getData(getUrlPage(url, page, pageSize ? pageSize : BOOKING_SUB_SIZE))
      return;
    }
    getData(getUrlPage(url, page, pageSize ? pageSize : BOOKING_SUB_SIZE))
  };

  const handleSelectFeedBack = (value: any) => {
    setFeedBackSelected(value);
    setStateApp({ ...stateApp, showBookingSubForm: true });
  };

  const handleDelete = (id: string) => {
    deleteBookingSubById(id)
      .then(() => {
        toast(NotifyType.SUCCESS, 'Xóa thành công');
        setBookingSubs(bookingSubs.filter((booking) => booking.id !== id));
      })
      .catch((error) => {
        toast(NotifyType.ERROR, 'Không thể xóa yêu cầu này');
      });
  };

  useEffect(() => {
    handlePageChange(0);
  }, [searchParams]);
  return (
    <div className="container flex flex-col mx-auto p-4 h-[98%]">
      <div className="p-2 flex items-center justify-between bg-white rounded">
        <div className="flex gap-4">
          <BookingSubModal
            stateApp={stateApp}
            setStateApp={setStateApp}
            data={feedBackSelected}
            updateData={getData}
          ></BookingSubModal>
          <div className="min-w-[170px] max-w-[170px] flex items-center gap-2">
            <Select className="w-full" placeholder="Trạng thái - Tất cả" defaultValue={'all'} style={{ flex: 1 }}
              onChange={(value) => handleOnchangeSelect(value)}
            >
              <Option value="all">Trạng thái - Tất cả</Option>
              <Option value={BOOKING_SUB_STATUS.OPEN}>Mở</Option>
              <Option value={BOOKING_SUB_STATUS.CLOSE}>Đóng</Option>
            </Select>
          </div>
        </div>
        <Input placeholder="Nhập từ khóa tìm kiếm" name="keyword" className="w-fit" onKeyDown={handleKeyPress} />
      </div>
      <div className="flex flex-col bg-white h-[100%] p-2 rounded-sm">
        <div className="overflow-x-auto bg-white">
          <table className="min-w-full bg-white border border-gray-300">
            <thead className="bg-[#f2f2f2]">
              <tr>
                <th className="border border-gray-300 text-center py-3 px-4 font-semibold text-sm">Chọn</th>
                <th className="border border-gray-300 text-left py-3 px-4  font-semibold text-sm">Họ và tên</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Ngày đăng ký</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Tên sách</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Trạng thái</th>
                <th className="border border-gray-300 text-center py-3 px-4  font-semibold text-sm">Hành động</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {bookingSubs?.map((booking: BookingSub) => (
                <tr key={booking?.id}>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    <input type="checkbox" />
                  </td>
                  <td className="border border-gray-300 text-left py-3 px-4 break-words cursor-pointer">
                    {booking?.nameUser}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {booking?.createdAt !== null ? convertDateTime(booking.createdAt) : null}
                  </td>
                  <td className="border border-gray-300 text-center py-3 px-4 break-words">
                    {booking?.book?.name}
                  </td>
                  <td
                    className={`border border-gray-300 text-center py-3 px-4 break-words ${getStatusClass(booking?.status)}`}
                  >
                    {booking?.status === BOOKING_SUB_STATUS.OPEN ? 'Đang mở' : 'Đóng'}
                  </td>

                  <td className="flex items-center justify-center border border-gray-300 text-center py-3 border-b-0">
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white py-1 rounded-lg mx-1 w-[40px]"
                      onClick={() => handleSelectFeedBack(booking)}
                    >
                      <EditOutlined />
                    </button>
                    <Popconfirm
                      title="Bạn có chắc muốn xóa đăng ký này?"
                      onConfirm={() => handleDelete(booking?.id)}
                      okText="Có"
                      cancelText="Không"
                    >
                      <button className="bg-red-500 hover:bg-red-700 text-white py-1 rounded-lg mx-1 w-[40px]">
                        <DeleteOutlined />
                      </button>
                    </Popconfirm>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* <div className="flex-grow"></div> */}
        <div className="flex justify-end mt-3 mb-2">
          <Pagination
            defaultCurrent={currentPage}
            total={bookingSubSize}
            pageSize={pageSize}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
